module.exports = __webpack_public_path__ + "img/blackcat1.06973320.jpg";